import React from 'react';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../constants';
import Field from '../../../../shared/ui/Field';
import { MAX_DESCRIPTION_SIZE } from '../../../../shared/configs/attachments';
import { useAttachmentDependentFieldConfig } from '../../controllers/useAttachmentsDependentFildConfig';
import TextFieldsExtra from '../TextFieldsExtra';

const name = fieldNames.description;

const DescriptionField = () => {
  const { rules, disabled } = useAttachmentDependentFieldConfig({
    name,
    maxSize: MAX_DESCRIPTION_SIZE,
    isRequired: false,
  });

  const {
    field,
    fieldState: { error },
  } = useFieldController({
    name,
    defaultValue: '',
    rules,
  });

  return (
    <Field.Memoized
      type={Field.types.textarea}
      value={field.value}
      onChange={field.onChange}
      disabled={disabled}
      formItemLabel="Описание"
      formItemValidateStatus={error?.message ? 'error' : undefined}
      autoSize={{ minRows: 2, maxRows: 5 }}
      formItemExtra={
        <TextFieldsExtra
          errorMessage={error?.message}
          maxSize={MAX_DESCRIPTION_SIZE}
          valueSize={field.value?.length ?? 0}
        />
      }
    />
  );
};

export default DescriptionField;
